var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Polaris-DataTable__Footer flex" }, [
    _c("div", { staticClass: "block" }, [
      _c("p", { staticClass: "text-sm leading-5 text-gray-700" }, [
        _vm._v(" Showing "),
        _c("span", { staticClass: "font-medium" }, [
          _vm._v(_vm._s(_vm.startingPagerValue) + " ")
        ]),
        _vm._v(" to "),
        _c("span", { staticClass: "font-medium" }, [
          _vm._v(_vm._s(_vm.pagerValue) + " ")
        ]),
        _vm._v(" of "),
        _c("span", { staticClass: "font-medium" }, [
          _vm._v(_vm._s(_vm.page.total) + " ")
        ]),
        _vm._v(" results ")
      ])
    ]),
    _c("div", { staticClass: "flex-1 flex justify-between sm:justify-end" }, [
      _c("nav", { attrs: { "aria-label": "Pagination" } }, [
        _c(
          "div",
          {
            staticClass: "Polaris-ButtonGroup Polaris-ButtonGroup--segmented",
            attrs: { "data-buttongroup-segmented": "true" }
          },
          [
            _c("div", { staticClass: "Polaris-ButtonGroup__Item" }, [
              _vm.page.page - 1 >= 1
                ? _c(
                    "button",
                    {
                      staticClass:
                        "Polaris-Button Polaris-Button--outline Polaris-Button--iconOnly",
                      attrs: {
                        id: "previousURL",
                        "aria-label": "Previous",
                        type: "button"
                      },
                      on: { click: _vm.loadPrevPage }
                    },
                    [
                      _c("span", { staticClass: "Polaris-Button__Content" }, [
                        _c("span", { staticClass: "Polaris-Button__Icon" }, [
                          _c("span", { staticClass: "Polaris-Icon" }, [
                            _c("span", {
                              staticClass:
                                "Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                            }),
                            _c(
                              "svg",
                              {
                                staticClass: "Polaris-Icon__Svg",
                                attrs: {
                                  viewBox: "0 0 20 20",
                                  focusable: "false",
                                  "aria-hidden": "true"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d:
                                      "M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414l-4.293 4.293 4.293 4.293a.999.999 0 0 1-.707 1.707z"
                                  }
                                })
                              ]
                            )
                          ])
                        ])
                      ])
                    ]
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "Polaris-ButtonGroup__Item" }, [
              _vm.page.pages > _vm.page.page
                ? _c(
                    "button",
                    {
                      staticClass:
                        "Polaris-Button Polaris-Button--outline Polaris-Button--iconOnly",
                      attrs: {
                        id: "nextURL",
                        "aria-label": "Next",
                        type: "button"
                      },
                      on: { click: _vm.loadNextPage }
                    },
                    [
                      _c("span", { staticClass: "Polaris-Button__Content" }, [
                        _c("span", { staticClass: "Polaris-Button__Icon" }, [
                          _c("span", { staticClass: "Polaris-Icon" }, [
                            _c("span", {
                              staticClass:
                                "Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                            }),
                            _c(
                              "svg",
                              {
                                staticClass: "Polaris-Icon__Svg",
                                attrs: {
                                  viewBox: "0 0 20 20",
                                  focusable: "false",
                                  "aria-hidden": "true"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d:
                                      "M8 16a.999.999 0 0 1-.707-1.707l4.293-4.293-4.293-4.293a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5a.997.997 0 0 1-.707.293z"
                                  }
                                })
                              ]
                            )
                          ])
                        ])
                      ])
                    ]
                  )
                : _vm._e()
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }